module.exports = __webpack_public_path__ + "static/media/wash-fold-service.f696bc82.png";